import { atom } from "jotai";
import type {
  DesignModerationStatus,
  DesignWidgetType,
  ListDesignsQuery,
} from "../types";

export const designStatusFilterAtom = atom<DesignModerationStatus>("pending");
export const designWidgetFilterAtom = atom<DesignWidgetType | "all">("all");
export const designSearchAtom = atom<string>("");
export const designPageAtom = atom<number>(1);

export const designFiltersAtom = atom<ListDesignsQuery>((get) => {
  const widgetType = get(designWidgetFilterAtom);
  const q = get(designSearchAtom).trim();

  const query: ListDesignsQuery = {
    status: get(designStatusFilterAtom),
    page: get(designPageAtom),
    limit: 24,
  };

  if (widgetType !== "all") query.widgetType = widgetType;
  if (q) query.q = q;

  return query;
});
